import React from 'react';
import { DishDescriptionFoodItemFragment } from 'src/gqlReactTypings.generated.d';
import { FoodItemWithOptionalQuantity } from 'src/pages/consumer/order/components/ConsumerOrderDishSelection';
import styled from 'styled-components';
import { Colors, Font, Spacing } from 'web-common/src/shared/styles';

// No need to alert above this number
export const CAPACITY_THRESHOLD = 3;

const Tag = styled.div`
  padding: ${Spacing.QUARTER} ${Spacing.THREE_QUARTERS};
  background-color: ${Colors.WHITE};
  color: ${Colors.GRAY_DARK_30};
  font-size: ${Font.Size.XXS};
  font-weight: ${Font.Weight.SEMI_BOLD};
  font-family: ${Font.Family.SANS};
  text-transform: uppercase;
  letter-spacing: 1px;
`;

interface IProps {
  foodItem: FoodItemWithOptionalQuantity & DishDescriptionFoodItemFragment;
  className?: string;
}
export const QuantityRemainingTag: React.FC<IProps> = ({ foodItem, className }) =>
  foodItem.quantityRemaining && foodItem.quantityRemaining <= CAPACITY_THRESHOLD ? (
    <Tag className={className}>Only {foodItem.quantityRemaining} Left!</Tag>
  ) : null;
